import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Logo from '../assets/images/logo.png';
import { Heart } from 'react-feather';
import { ShoppingCart } from 'react-feather';
import { Bell } from 'react-feather';
import { User } from 'react-feather';
import { Link } from 'react-router-dom';
import { ChevronDown, CheckCircle } from 'react-feather';
import bronzeStar from '../assets/images/bronze-star.png';
import LanguageChangeSVG from '../assets/images/languageChange.svg'
import ProfileService from '../services/Profile';
import { useSelector, useDispatch } from 'react-redux';
import NotificationService from '../services/Notification';
import { addTotalBellItems, addTotalCartItems } from '../redux/slices/countSlice';
import Loader from '../component/Loader'
import RefreshTokenService from '../services/RefreshToken';
import CartService from '../services/Cart';
import { useRef } from 'react';
import RegistrationService from '../services/registration';
import { addCurrentBrand, addToken, addTotalBrands } from '../redux/slices/userTypeSlice';
import toast from 'react-hot-toast';
import { formatNumberWithCommas } from '../constants/commonFunction';
import RewardsConnectLogo from './RewardsConnectLogo';
import { addUserData, addPersonalInfoResponse } from '../redux/slices/userTypeSlice';
import { jwtDecode } from "jwt-decode";

const TopBar = () => {
    const navigate = useNavigate()
    let allBrands = [];
    allBrands =  useSelector(
        state => state.userTypeSlice.totalBrands,
      );
    const currentBrand =  useSelector(
        state => state.userTypeSlice.currentBrand,
      );
    const pointDetails = useSelector(
        state => state.userPoints.pointDetails,
      );

    const[isLogin,setIsLogin] = useState(false)
    const topMenuRef = useRef(null)
    const languageMenuRef = useRef(null);
    const brandMenuRef = useRef(null);
    const dispatch = useDispatch()
    const [isUserAllInfo, setUserAllInfo] = useState();
    const [showBrands, setShowBrands] = useState(false);
    // Wishlist count
    const totalWishlistItems = useSelector(state => state.countSlice.wishlistCount)
    //Cart Count
    const totalCartItems = useSelector(state => state.countSlice.cartCount) // cartCount =  current state, countSlice = reducer, cartCount = state name
    //Notification Count
    const totalNotificationItems = useSelector(state => state.countSlice.bellCount)
    //Notification From Start
    const [notificationNo, setNotificationNo] = useState()
    //Other Variable
    const [topMenuList, setTopMenuList] = useState(false)
    const [topLanguageList, setTopLanguageList] = useState(false)
    const [loading, setLoading] = useState(true);
    //Logout after token Time end//
     useEffect(()=> {
        const token = localStorage.getItem('access_token')
        const isAuthenticated = !!token;
        // if(!allBrands)
        //     setShowBrands(false)
        // setInterval(()=>{
        //     const refreshToken = localStorage.getItem("refresh_token");
        //     const payload = {
        //         access_token: refreshToken,

        //     }
        //     const refreshTokenDataExpire = async () =>{
        //         try{
                   
        //             const refreshTokenDataExpireResponse = await RefreshTokenService.tokenStatus(payload)
        //             if (refreshTokenDataExpireResponse.success && refreshTokenDataExpireResponse.response.loginStatus == 'false') {
        //                 // 
        //                 handleLogOut();
        //               }
        //         }
        //         catch(e){
        //             console.error('refreshTokenDataExpire', e)
        //         }

        //     }
        //     refreshTokenDataExpire()

        // },20000)
        setIsLogin(true)

     },[])
    //User Name Display
    const [personaiInfo, setPersonalInfo] = useState({ full_name: ''})
    useEffect(() => {
        const userInfo = JSON.parse(localStorage.getItem('userData'));
        const contactId = userInfo.dcm_contacts_id;
        const conId = contactId;
        const token = localStorage.getItem('access_token')
        //Personal Info Show API//
        ProfileService.getPersonalInfo(token)
          .then(res => {
            setPersonalInfo(res?.response?.Data)
          })
          .catch(() => {
            console.error('Failed to fetch personal information');
        });
       },[currentBrand])
//TopMenu
// Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (topMenuRef.current && !topMenuRef.current.contains(event.target)) {
        setTopMenuList(false);
      }
      if (languageMenuRef.current && !languageMenuRef.current.contains(event.target)) {
        setTopLanguageList(false);
      }
      if (brandMenuRef.current && !brandMenuRef.current.contains(event.target)) {
        setShowBrands(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
    const handleshowTopMenuList = () =>{
        setTopMenuList(!topMenuList);
    }
    //Notification
    useEffect(()=>{
            const NotificationData = async () =>{
                try{
                    const token = localStorage.getItem('access_token');
                    const NotificationResponse = await NotificationService.totalUnreadNotifications(token);
                    if(NotificationResponse.error == false)
                    {   
                        dispatch(addTotalBellItems({bellCount:NotificationResponse.data["unread-notification"]}))
                    }

                }
                catch(error){
                    console.error('NotificationData')
                }
            }
            // NotificationData()
            // setInterval(() => {
               NotificationData()
            // }, 5000)
    },[currentBrand])
    

    //Tier Name
    useEffect(() => {
        const ProfileDataFetch = async () => {
          try {
            const token = localStorage.getItem('access_token');
            const userInfo = JSON.parse(localStorage.getItem('userData'));
            const contactId = userInfo.dcm_contacts_id;
            const personalInfoResponse = await ProfileService.getProfile(contactId, token);
            
    
            if (personalInfoResponse.success == true && personalInfoResponse.response.message != null) {
              setUserAllInfo(personalInfoResponse.response.message)
              setLoading(false)
              setTimeout(() => {
                dispatch(addUserData({userData: personalInfoResponse.response.message}))
                dispatch(addPersonalInfoResponse({personalInfoResponse: personalInfoResponse}))
              }, 1000)
            }
          }
          catch (error) {
            console.error('ProfileDataFetch Error')

          }
        }
        ProfileDataFetch()
      }, [currentBrand])
      
    //Logout
    // const handleLogOut = ()=>{
    //     localStorage.clear();
    //      window.location.reload();
    //     dispatch(addTotalCartItems({
    //         cartCount:0
    //     }))
    //     navigate('/');
       
    // }

    const handleLogOut = async () => {
        try {
            await RegistrationService.logout();
            localStorage.clear();
            dispatch(addTotalCartItems({
                cartCount: 0,
            }));

            navigate("/", { replace: true });
        } catch (error) {
            console.error("Logout failed:", error);
            localStorage.clear();
            dispatch(addTotalCartItems({
                cartCount: 0,
            }));
        
            // navigate("/", { replace: true });
        }
    };

    const handleshowLanguageList = ()=>{
        setTopLanguageList(!topLanguageList)
    }
    const handleshowBrandList = (e)=>{
        e.stopPropagation()
        setShowBrands(p => !p)
    }

    function changeBrand(brand) {
        const payload = {
            brand_id: brand.id,
          };
          RegistrationService.changeBrand(payload)
            .then(async res => {
                setLoading(true);
                setShowBrands(false);
              if (res.success == true) {
                  
                  navigate('/landing')

                const access_token = res.response.access_token;
               
                localStorage.setItem('access_token', access_token);
                localStorage.setItem(
                  'refresh_token',
                  res.response.refresh_token,
                );
                localStorage.setItem('currentBrand', JSON.stringify(brand));
                
                    
                setTimeout(() => {
                    dispatch(addCurrentBrand({currentBrand: brand}))
                    dispatch(addToken({token: {
                        access: access_token,
                        refresh: res.response.refresh_token,
                    }}));
                    const allBrand = JSON.parse(localStorage.getItem('allBrand'));
                    dispatch(addTotalBrands({totalBrands: allBrand}))

                }, 1000)
                // setToken(access_token);
                // cartCount(access_token);
                // pointsNew(access_token);
                // salesTarget(access_token);
                // getCatalogueList(access_token);
                // getBannerDashboard(access_token);
                // getDataList(access_token);

                toast.success("brand changed successfully")
                navigate('/');
              } else {
                toast.error("Something went wrong")
              }
            })
            .catch(err => {
              //setLoading(false);
            }).finally(() => {
                setLoading(false);
            });
    }
    //Cart Count
    function startCartCount() {
        const token = localStorage.getItem('access_token')
        CartService.cartItemCount(token).then(res => {
            if (!res.error) {
                dispatch(addTotalCartItems({
                    cartCount: Number(res?.data?.cartCountProducts)
                }))
            }
        }).catch(e => {
            console.error('startCartCountResponse')
        })
        }
    useEffect(()=>{
        startCartCount()
    },[currentBrand])

    //Wishlist Count

    function reset(){
        setShowBrands(false)
    }
    console.log("point details----->", pointDetails);
    
    
    return (
        <>
             {loading && <Loader/>}
            <div className='topBar' onClick={reset}>
                <Container className='position-relative'>
                    <Row>
                        <Col xs={12} sm={3} lg={3}>
                            <div className='logoBox'>
                                <RewardsConnectLogo alt='Logo'  className='img-fluid' />
                                {/* <img src={Logo} alt='Logo'  className='img-fluid'/> */}
                            </div>
                        </Col>
                        <Col xs={12} sm={9} lg={9}>
                            <div className='logoBoxRightSide'>
                                <ul>
                                    <li>
                                        <Link to ='/wishlist'><Heart/></Link>
                                    </li>
                                    <li>
                                        <Link to ='/cart'><ShoppingCart/> {totalCartItems > 0 && (<span className='notification-bell'>{totalCartItems > 0 ? totalCartItems : '' }</span>)}</Link>
                                    </li>
                                    {/* <li>
                                        <Link to = '/notification'><Bell/>{totalNotificationItems > 0 && (<span className='notification-bell'> {totalNotificationItems > 0 ? totalNotificationItems : ''}</span>)}</Link>
                                    </li> */}
                                    <li>
                                        <Link to='/notification'>
                                            <Bell />
                                            {totalNotificationItems > 0 && (
                                                <span className='notification-bell'>
                                                    {totalNotificationItems}
                                                </span>
                                            )}
                                        </Link>
                                    </li>
                                </ul>
                                {allBrands && <ul>
                                    <li>
                                        <Link onClick={handleshowBrandList}> Brand <ChevronDown/></Link>
                                    </li>
                                    
                                </ul>}
                                {/* <ul>
                                    <li>
                                        <Link onClick={handleshowLanguageList}> <img src = {LanguageChangeSVG} /> Eng <ChevronDown/></Link>
                                    </li>
                                    
                                </ul> */}
                                <ul>
                                    <li >
                                       <img src= {bronzeStar} alt='bronzeStar' className='starImage'/><Link onClick={handleshowTopMenuList}><User/> {personaiInfo?.full_name} <ChevronDown/> </Link>
                                    </li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                    {topLanguageList &&
                     <div className='languageMenu' ref={languageMenuRef} style={{zIndex: 501}}>
                     <ul>
                        <li>
                             <Link>
                                 Eng
                             </Link>
                         </li>
                         <li>
                             <Link>
                                Eng
                             </Link>
                         </li>
                         <li>
                             <Link>
                                Eng
                             </Link>
                         </li>
                         
                     </ul>
                 </div>
                    }
                    {/* {showBrands &&
                     <div className='languageMenu brandMenu' ref={brandMenuRef}>
                     <ul>
                        {allBrands && allBrands.map(item => {
                            return (
                                <li key={item.id} onClick={() => changeBrand(item)}>
                                        <div className='separateHorizontal'>
                                            <img src={item.image.uri} alt='Logo'  className='img-fluid'/>
                                            {currentBrand.id == item.id && <CheckCircle color='green' />}
                                        </div>
                                </li>
                            )
                        })}
                         
                     </ul>
                 </div>
                    } */}

                    {showBrands && (
                        <div className='languageMenu brandMenu' ref={brandMenuRef}>
                            <ul>
                                {allBrands &&
                                    allBrands.map(item => (
                                        <li
                                            key={item.id}
                                            onClick={() => {
                                                if (allBrands.length > 1) {
                                                    changeBrand(item);
                                                }
                                            }}
                                            style={{
                                                cursor: allBrands.length === 1 ? 'default' : 'pointer',
                                                pointerEvents: allBrands.length === 1 ? 'none' : 'auto'
                                            }}>
                                            <div className='separateHorizontal'>
                                                <img
                                                    src={item.image.uri}
                                                    alt='Logo'
                                                    className='img-fluid'
                                                />

                                                    {currentBrand.id === item.id && (
                                                        <CheckCircle color='green' />
                                                    )}
                                            </div>
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    )}

                    {topMenuList && 
                    <div className='profileMenu' ref={topMenuRef} onClick={() => setTopMenuList(false)}>
                        <ul>
                            {(personaiInfo?.dcm_hierarchies_id !== 18) && <li>
                                Avilable Point: {formatNumberWithCommas(pointDetails?.opening_balance)} {pointDetails?.opening_balance > 0 && isUserAllInfo?.tierName !=''|| null && <span className='tierNameColor'>{isUserAllInfo?.tierName}</span>}
                            </li>}
                            <li>
                                <Link to='/profile'>
                                    My Profile
                                </Link>
                            </li>
                            {(personaiInfo?.dcm_hierarchies_id !== 18)? <li>
                                <Link to = '/my-point-statement'>
                                    My Point Statement
                                </Link>
                            </li> : null}
                            
                            <li>
                                <Link onClick={handleLogOut}>
                                    Logout
                                </Link>
                            </li>
                        </ul>
                    </div>}
                </Container>
            </div>

        </>
    )
}

export default TopBar